/**
 * Signing in and choosing a password (المرحلة 1.1), without React: which
 * label the one sign-in field wears, and how strong a new password reads.
 */

/**
 * The sign-in field's label and placeholder for the methods the platform
 * opened (GET /api/auth/policy → signIn). Username alone is today's screen.
 *
 * @param {string[]} methods  any of 'username', 'email', 'phone'
 * @param {(key: string, vars?: object) => string} t
 * @param {string} example  a mobile in the institution country's shape
 */
export function identifierCopy(methods, t, example) {
  const set = new Set(methods && methods.length ? methods : ['username']);
  if (set.has('email') && set.has('phone')) return { label: t('auth.idAll'), placeholder: t('auth.idPlaceholderAll', { example }), type: 'text' };
  if (set.has('email')) return { label: t('auth.idEmailOrUser'), placeholder: 'name@example.com', type: 'text' };
  if (set.has('phone')) return { label: t('auth.idPhoneOrUser'), placeholder: example, type: 'text' };
  return { label: t('auth.idUsername'), placeholder: t('auth.idUsername'), type: 'text' };
}

/**
 * How strong, 0–4, by length and character variety. Presentation only: the
 * server's rule is what accepts or refuses. One scale for the change-password
 * form and the reset screen, so a password reads the same on both.
 */
export function passwordStrength(value) {
  const v = String(value || '');
  let score = 0;
  if (v.length >= 6) score += 1;
  if (v.length >= 10) score += 1;
  if (/[A-Z]/.test(v) && /[a-z]/.test(v)) score += 1;
  if (/\d/.test(v) && /[^A-Za-z0-9]/.test(v)) score += 1;
  return score;
}
